"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextResource = void 0;
const de_1 = __importDefault(require("../language/de"));
const en_1 = __importDefault(require("../language/en"));
const uk_1 = __importDefault(require("../language/uk"));
const model_1 = require("./model");
const languages = new Map([
    [model_1.SupportedLanguages.DE, de_1.default],
    [model_1.SupportedLanguages.EN, en_1.default],
    [model_1.SupportedLanguages.UK, uk_1.default],
]);
const getTextResource = (language = model_1.SupportedLanguages.DE) => {
    return languages.get(language);
};
exports.getTextResource = getTextResource;
